export default __webpack_public_path__ + "static/media/Services4.98b0fdb8.jpg";